<template>
    <div>
        <section class="tab mb-4">
            <nav>
                <a v-for="(terminal, index) in terminals"
                    href="#"
                    :class="{'active': activeTerminal == terminal.slug}"
                    :key="index"
                    @click.prevent="setTerminal(terminal.slug)">

                    {{terminal.title}}
                </a>
            </nav>

            <div class="tab-container terminals-map" v-if="activeTerminal">
                <div class="tab-container-map my-4" id="tab-container-map"> 
                    <img v-if="image" :src="image" :data-zoom-src="imageFullSize" class='term-img-fluid' alt='asur' width="800" height="600" data-zoomable @click.prevent="toggleZoom"/>
                </div>

                <!--<div class="domNode" style="z-index: 9999;">
                    <div id="domNode" style="z-index: 9999;"></div>
                </div>-->
                
                <div class="tab-container-list">
                    <label>{{floor || 'Planta baja'}}</label>

                    <ul class="col3">
                        <a v-for="(store, index) in stores[page]"
                            class="capitalize secret-class"
                            :href="`/${locale}/${locale == 'es' ? 'tiendas' : 'stores'}/${store.slug}`"
                            :key="index">
                            {{store.location ? store.location < 10 ? `0${store.location}` : store.location : '--'}}: 
                            {{store.title ? store.title.toLowerCase() : ''}}
                        </a>
                    </ul>

                    <Pagination
                        position="align-items-center justify-content-center"
                        :pages="pages"
                        v-model="page"
                        :total="total"
                        :customMessage="customMessage"/>
                </div>  
            </div>
        </section>
    </div>
</template>
<script>
import _ from 'lodash';
import mediumZoom from 'medium-zoom'
import Pagination from '../filters-with-list/components/Pagination.vue';

export default {
    props: {
        terminals: Array,
        locale: String
    },
    data: () => ({
        activeTerminal: null,
        imagesZoomable: null,
        page: 0,
        isMobile: false,
        imgZoom: null
    }),
    components: { Pagination },
    mounted() {
        this.activeTerminal = this.terminals && this.terminals[0] ? this.terminals[0].slug : null;
        this.handler();
    },
    computed: {
        maps() {
            return this.activeTerminal ? (this.terminals.find(x => x.slug === this.activeTerminal) || {}).maps : null
        },
        currentMap() {
            return this.maps ? (this.maps.find(x => x[this.isMobile ? 'pages_mobile' : 'pages'].includes(this.page + 1)) || {}) : null
        },
        floor() {
            return this.$locale === 'es' ? this.currentMap.floor?.replace('Top floor', 'Planta alta')?.replace('Low level', 'Planta baja') : this.currentMap.floor;
        },
        mapImage() {
            return this.currentMap?.map || this.maps?.find(m => m.floor === 'Low level')?.map
        },
        image() {
            return this.mapImage ? `/public-assets/${this.mapImage.slug}?size=map` : null
        },
        imageFullSize() {
            return this.mapImage ? `/public-assets/${this.mapImage.slug}` : null
        },
        stores() {
            return this.activeTerminal ? (this.terminals.find(x => x.slug === this.activeTerminal) || {})[this.isMobile ? 'stores_mobile' : 'stores'] : null
        },
        total() {
            return this.activeTerminal ? (this.terminals.find(x => x.slug === this.activeTerminal) || {}).stores_count : null
        },
        pages() {
            return this.stores ? this.stores.length : 0
        },
        messageHelper() {
            return this.stores.reduce((carry, value, index) => index > this.page ? carry : value.length + carry , 0)
        },
        customMessage() {
            return `Mostrando ${this.messageHelper} de ${this.total}`
        }
    },
    watch: {
        activeTerminal: {
            handler: function () {
                this.page = 0;
            },
            inmediate: true
        },
        isMobile: {
            handler: function () {
                this.page = 0;
            },
            inmediate: true
        },
        image: {
            handler:  _.debounce(function () {
                this.setImgZoomable();
            }, 50),
            inmediate: true,
            deep: true
        }
    },
    created() {
        window.addEventListener("resize", this.handler);
    },
    destroyed() {
        window.removeEventListener("resize", this.handler);
    },
    methods: {
        setTerminal(terminal) {
            this.activeTerminal = terminal;
        },
        toggleZoom() {
            if (this.imagesZoomable == null);
            this.imagesZoomable.toggle()
        },
        setImgZoomable() {
            if (this.imagesZoomable) {
                this.imagesZoomable.close();
                this.imagesZoomable.detach();
                this.imagesZoomable = null;
            }

            this.imagesZoomable = Object.assign({}, mediumZoom('[data-zoomable]', {
                margin: 24,
                background: '#ffffff',
                scrollOffset: 200 /* The number of pixels to scroll to close the zoom = > Your 40px */
            }));

            // const domNode = document.getElementById("domNode");
            // domNode.classList.add('active')
            // var options = {
            //     width: 1000,
            //     zoomContainer: domNode
            // };
            // this.imgZoom = new ImageZoom(document.getElementById("tab-container-map"), options);
        },
        handler(e = null) {
            const width = document.body.clientWidth;
            this.isMobile = width <= 425;
        }
    }
}
</script>
<style lang="scss" scoped>
.capitalize {
    text-transform: capitalize;
}
</style>